import type { FaireProductEntity } from "../../entity_types/product";

export const p_twvrkjbkuh: FaireProductEntity = {
  token: "p_twvrkjbkuh",
  type: "product",
  name: "Asa Bench Cushion in Clay Melange",
  brandToken: "b_8qfvgpu7nc",
  brandName: "",
  imageUrl:
    "https://cdn.faire.com/fastly/6d2618a7f8bc5636cb98e5dba76dd18301a7a6599400cfc64aad930d66cdb079.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3565aac1580b5e2a90e2703d99d7a3ba5a520aa56f6dfaf2496f25af182a90dc.jpeg",
    "https://cdn.faire.com/fastly/439f12112642774e552f756d1c34bf5b763837a4410838dc46652636bd6f6199.jpeg",
    "https://cdn.faire.com/fastly/d0a43e0ca0b21ff56bf7b3bf5bb151f6186a52185e67b34bc0b104f60d06fcbc.jpeg",
  ],
  priceDollars: 48.65,
  description:
    'Our Asa Bench Cushion is made of 100% cotton and a beautiful leather piping. The cotton cover is soft to the touch, while the natural leather piping adds a touch of elegance to the design. The Seat Cushion provides additional seating comfort, and will withstand frequent use, maintaining its shape and comfort over time. Spot cleaning only.\n\nProduct Overview\n\n * Color: Clay Melange \n * Dimensions: 42.91"L x 13.39"W x 1.57"H \n * Material: Cotton, leather, foam ',
  tags: [],
  msrpDollars: 97.3,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-07T04:57:35.146Z",
    importedBy: "gen-brand-update-tile-products.mjs",
  },
  categoryTokens: [],
};
